import { colors } from '@/lib/analytics/colors';
import { SIZE_50 } from '@/lib/gridElements/size';
import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const reachRateFollowersMVConfig: KpiType<
    typeof MediaViewerKpiLoader,
    typeof MediaViewerKPI
> = {
    name: 'kpi.facebook.reach_rate_followers',
    id: 'reach_rate_followers',
    icon: {
        name: 'reach',
        style: colors.purple
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_PERCENT,
    size: SIZE_50,
    type: 'kpi',
    mergedData: true,
    orientation: ORIENTATION_VERTICAL,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
